import { ca } from '@cian/analytics';

export function trackFullscreenClose(objectType?: string) {
  ca('eventSite', {
    action: 'fullscreen',
    category: 'Infrastructure',
    label: 'close_show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
